var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMississippi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.354,174.503l2.682-140.516l-79.144,5.701c0,0,1.676,5.365,0,6.038c-1.678,0.671-7.378,3.688-8.384,7.042 c-1.006,3.354-2.683,6.707-2.683,6.707s1.007,7.041,0,7.378c-1.007,0.336-11.068,10.062-11.403,12.409 c-0.335,2.347-0.669,9.388-4.024,8.717l-3.687,18.447c0,0,1.339,8.047,3.018,12.743c1.676,4.695,3.017,8.384-0.671,13.414 l-1.593,9.055l4.277,9.055l-1.007,4.694l5.365,6.708c-1.342,9.054-19.785,40.576-19.785,40.576l-0.669,20.794l71.765-3.355 l-2.348,15.427l7.377,6.372l3.02,12.073l10.061-9.726l3.354,2.348c0,0,12.744-4.359,15.09-4.025c2.35,0.336,3.689,3.355,6.037,3.355 s10.396-1.008,10.396-1.008l1.676-4.358L198.354,174.503z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMississippi);
export default __webpack_public_path__ + "static/media/mississippi.545d311b0376fe03ccc829754169be7a.svg";
export { ForwardRef as ReactComponent };